import { render, staticRenderFns } from "./create_or_update.vue?vue&type=template&id=1802fd6c&scoped=true"
import script from "./create_or_update.vue?vue&type=script&lang=js"
export * from "./create_or_update.vue?vue&type=script&lang=js"
import style0 from "./create_or_update.vue?vue&type=style&index=0&id=1802fd6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1802fd6c",
  null
  
)

export default component.exports